module.exports = __webpack_public_path__ + "static/my_id_logo-6ad4bbd94a50079192b6f3d4fc198418.png";